/* eslint-disable react/prop-types */
// dependencies
import React from "react";

// components
import Checkbox from "../../../../../../components/Inputs/Checkbox";
import OverflowTooltip from "../../../../components/OverflowTooltip";

// schema
import { IQuestionGroupingTableRow } from "./schema";

interface BaseProps {
	cellData: {
		selectedQuestionIDs: string[];
		questionData: IQuestionGroupingTableRow;
		disabled: boolean;
		toggleSelectedQuestion: (questionID: string) => void;
	};
}

export const CheckBoxCell = (props: BaseProps) => {
	const { selectedQuestionIDs, questionData, disabled, toggleSelectedQuestion } = props.cellData;

	const questionID = questionData.id;
	const isChecked = selectedQuestionIDs.includes(questionID);

	return (
		<span data-testid={`group-checkbox-${isChecked ? "checked" : "unchecked"}`}>
			<Checkbox onChange={() => toggleSelectedQuestion(questionID)} value={isChecked} disabled={disabled} />
		</span>
	);
};

export const QuestionCell = ({ cellData }: BaseProps) => <OverflowTooltip value={cellData.questionData.question} />;

export const ReviewFormCell = ({ cellData }: BaseProps) => (
	<OverflowTooltip value={cellData.questionData.reviewForm || ""} />
);

export const SurveyFormCell = ({ cellData }: BaseProps) => (
	<OverflowTooltip value={cellData.questionData.surveyName || ""} />
);

export const QuestionTypeCell = ({ cellData }: BaseProps) => <div>{cellData.questionData.questionType}</div>;
